import React from "react";
import { Box } from "@mui/material";
import { tokens, SEMANTIC } from "./tokens";

/**
 * Status Pill (§5.3) — pastilla compacta: punto semántico + texto.
 * Nunca comunica con color solamente: siempre lleva símbolo + label.
 *
 * @param {"ok"|"warn"|"crit"|"info"|"muted"} tone
 * @param {string} label
 * @param {boolean} [dense] - versión más compacta para celdas de tabla
 */
export default function StatusPill({ tone = "muted", label, dense = false, sx }) {
  const t = SEMANTIC[tone] || SEMANTIC.muted;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        px: dense ? 0.9 : 1.2,
        py: dense ? "1px" : "3px",
        borderRadius: "999px",
        bgcolor: t.bg,
        color: t.fg,
        fontFamily: tokens.fontUI,
        fontSize: dense ? 11.5 : 12.5,
        fontWeight: 500,
        lineHeight: 1.6,
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      <Box component="span" sx={{ fontSize: dense ? 9 : 10, lineHeight: 1 }}>
        {t.dot}
      </Box>
      {label}
    </Box>
  );
}
